import { Progress } from '@radix-ui/themes';
import React, { useEffect, useState } from 'react';

function SiteLoading() {
  const [render, setRender] = useState(false);

  useEffect(() => {
    // Set to 200ms because that's what it defaults to in react-loadable
    // https://github.com/jamiebuilds/react-loadable#avoiding-flash-of-loading-component
    const timer = setTimeout(() => setRender(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return !render ? null : <Progress duration='2s' />;
}

export default SiteLoading;
